import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { footer } = content;

        return (
            <div className={styles.bottomFooter}>
                <Footer content={footer} />
            </div>
        );
    }
}

export default errorBoundary(BottomFooter);
